import { render, staticRenderFns } from "./PostCreateModal.vue?vue&type=template&id=898d46a4&scoped=true"
import script from "./PostCreateModal.vue?vue&type=script&lang=js"
export * from "./PostCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898d46a4",
  null
  
)

export default component.exports